"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
var _clsx = _interopRequireDefault(require("clsx"));
var _ReactSVGIcon = _interopRequireDefault(require("@micado-digital/react-svg-icon/ReactSVGIcon"));
var _toggleBookmark = _interopRequireDefault(require("@micado-digital/react-bookmark/ReactBookmark/toggleBookmark"));
var _ShopContext = _interopRequireDefault(require("../../../context/ShopContext"));
var _ProductDetailContext = _interopRequireDefault(require("../../../ProductDetail/context/ProductDetailContext"));
var _fireEvent = _interopRequireDefault(require("../../../utils/fireEvent"));
var _Bookmark = _interopRequireDefault(require("./Bookmark.styles"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
var Bookmark = function Bookmark() {
  var _useContext = (0, _react.useContext)(_ShopContext.default),
    shopData = _useContext.shopData;
  var _useContext2 = (0, _react.useContext)(_ProductDetailContext.default),
    productDetailData = _useContext2.productDetailData;
  var _ref = productDetailData || {},
    _ref$combinationID = _ref.combinationID,
    combinationID = _ref$combinationID === void 0 ? 0 : _ref$combinationID,
    _ref$objectType = _ref.objectType,
    objectType = _ref$objectType === void 0 ? "shop-product" : _ref$objectType;
  var css = (0, _Bookmark.default)();
  var handleAddToBookmark = function handleAddToBookmark() {
    (0, _fireEvent.default)("add-to-bookmark", {
      product: productDetailData,
      shop: shopData
    });
  };
  var handleRemoveFromBookmark = function handleRemoveFromBookmark() {
    (0, _fireEvent.default)("remove-from-bookmark", {
      product: productDetailData,
      shop: shopData
    });
  };
  return /*#__PURE__*/_react.default.createElement(_toggleBookmark.default, {
    className: (0, _clsx.default)(css.bookmark, "mco-shop-product-detail-bookmark"),
    componentBookmarked: /*#__PURE__*/_react.default.createElement(_ReactSVGIcon.default, {
      color: "primary",
      src: "/img/icons/shop/bookmark-selected.svg",
      size: 24
    }),
    componentBookmarkedHover: /*#__PURE__*/_react.default.createElement(_ReactSVGIcon.default, {
      color: "primary",
      src: "/img/icons/shop/bookmark-selected.svg",
      size: 24
    }),
    componentDefault: /*#__PURE__*/_react.default.createElement(_ReactSVGIcon.default, {
      color: "primary",
      src: "/img/icons/shop/bookmark.svg",
      size: 24
    }),
    componentHover: /*#__PURE__*/_react.default.createElement(_ReactSVGIcon.default, {
      color: "primary",
      src: "/img/icons/shop/bookmark-selected.svg",
      size: 24
    }),
    data: _objectSpread(_objectSpread({}, productDetailData), {}, {
      combinationID: combinationID,
      objectType: objectType
    }),
    validationFields: ["id", "combinationID", "objectType"],
    onAdded: handleAddToBookmark,
    onRemoved: handleRemoveFromBookmark
  });
};
var _default = Bookmark;
exports.default = _default;